
const Table = () => import('@/../../coreui/components/ServerTable')
const DisCart = () => import('../../components/distribution/ShopOld')
const DisReports = () => import('../../components/distribution/ReportsGenerator')

export default function buildMenu (allowed) {
  var routes = []
  if (allowed == null || allowed.includes('Distribution'))  {
    routes = [
      {
        path: '/DisSales',
        name: 'DisSales',
        component: Table,
        props: {
          schema: 'sch_dis_sales', 
          table: 'dis_sales'
        } 
      }, {
        path: '/DisInventory',
        name: 'DisInventory',
        component: Table,
        props: {
          schema: 'sch_fac_inventory', 
          table: 'fac_inventory'
        } 
      }, 
      {
        path: '/DisReports',
        name: 'DisReports',
        component: DisReports
      },
      {
        path: '/DisCart',
        name: 'DisCart',
        component: DisCart
      }, 
      {
        path: '/DisProducts',
        name: 'DisProducts',
        component: Table,
        props: {
          schema: 'sch_fac_products', 
          table: 'fac_products'
        }
      }
    ]
  } 
  return routes
}
